import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AuthDirective } from '@monorepo-channels/channels/domain'
import { HeaderComponent } from '@monorepo-channels/components/feature-porto-bank'

@Component({
	standalone: true,
	imports: [RouterModule, HeaderComponent],
	selector: 'porto-bank-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	hostDirectives: [AuthDirective],
})
export class AppComponent {
	title = 'porto-bank'
}
